<div class="row mt-5">
    <div class="col-12 col-md-6 order-12 order-md-1">
        <button type="button" class="gb-secondary-button" (click)="cancelClick()">
          {{getCopyByCode('checkout.cancel')}}
        </button>
    </div>
    <div class="col-12 col-md-6 order-2 mb-3">
        <button type="button" class="gb-primary-button" [class.disabled]="disableSaveButton" [disabled]="disableSaveButton" (click)="onSaveClick()">
          @if (!saving) {
            {{getCopyByCode('checkout.save')}}
          }
          @else {
            <ox-loading></ox-loading>
          }
        </button>
    </div>
</div>